<template>
      <a href="https://widget.socialman.net"  id="socialwidget" data-ref="234e5dc39dc52740524f9d863bec963c" class="srfl" >Giveaway</a>
</template>

<script>
export default {
  data() {
    return {
      msg: " "
    };
  },
  mounted(){
        var anchor = document.getElementById("socialwidget")
      , url = document.referrer
      , sm_resize = function(e) {
        e.origin;
        var r = document.getElementById("sm_iframe");
        if (r) {
            var a = e.data;
            isNaN(a) || (a += 2),
            r.style.height = a + "px"
        }
    };
   window.addEventListener ? window.addEventListener("message", sm_resize, !1) : window.attachEvent && window.attachEvent("onmessage", sm_resize);
    var referral = "";
    void 0 !== anchor.dataset.ref && (referral = anchor.dataset.ref),
    anchor.innerHTML = '<iframe style="border: 1px solid #ccc; width:480px; max-width:100%; box-sizing:border-box; overflow:hidden;" scrolling="no" src="https://widget.socialman.net/' + anchor.dataset.ref + "/actions?data_ref=" + encodeURIComponent(url) + ("" !== referral ? "&data_referral=" + referral : "") + '" id="sm_iframe"></iframe>';

     //  var anchor=document.getElementById("socialwidget"),url=document.referrer,sm_resize=function(e){e.origin;var r=document.getElementById("sm_iframe");if(r){var a=e.data;isNaN(a)||(a+=2),r.style.height=a+"px"}};window.addEventListener?window.addEventListener("message",sm_resize,!1):window.attachEvent&&window.attachEvent("onmessage",sm_resize);var referral="";void 0!==anchor.dataset.referral&&(referral=anchor.dataset.referral),anchor.innerHTML='<iframe style="border: 1px solid #ccc; width:480px; max-width:100%; box-sizing:border-box; overflow:hidden;" scrolling="no" src="https://widget.socialman.net/'+anchor.dataset.ref+"/actions?data_ref="+encodeURIComponent(url)+(""!==referral?"&data_referral="+referral:"")+'" id="sm_iframe"></iframe>';
  }
};
</script>

<style scoped>
a#socialwidget {

    max-width: 474px !important;
    width: 100%;
}
@media only screen and (max-width: 1199px) {
  a#socialwidget {
        width: 100% !important;
    max-width: 474px !important;
    margin-top: 14px;
}
  
}
</style>


// WEBPACK FOOTER //
// src/components/giveawayIframe.vue